"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return GalleryViewColumn;
    }
});
const _View = /*#__PURE__*/ _interop_require_default(require("~/models/View"));
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _NocoCache = /*#__PURE__*/ _interop_require_default(require("~/cache/NocoCache"));
const _extractProps = require("~/helpers/extractProps");
const _globals = require("~/utils/globals");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let GalleryViewColumn = class GalleryViewColumn {
    static async get(context, galleryViewColumnId, ncMeta = _Noco.default.ncMeta) {
        let viewColumn = galleryViewColumnId && await _NocoCache.default.get(context, `${_globals.CacheScope.GALLERY_VIEW_COLUMN}:${galleryViewColumnId}`, _globals.CacheGetType.TYPE_OBJECT);
        if (!viewColumn) {
            viewColumn = await ncMeta.metaGet2(context.workspace_id, context.base_id, _globals.MetaTable.GALLERY_VIEW_COLUMNS, galleryViewColumnId);
            if (viewColumn) {
                await _NocoCache.default.set(context, `${_globals.CacheScope.GALLERY_VIEW_COLUMN}:${galleryViewColumnId}`, viewColumn);
            }
        }
        return viewColumn && new GalleryViewColumn(viewColumn);
    }
    static async insert(context, column, ncMeta = _Noco.default.ncMeta) {
        const insertObj = (0, _extractProps.extractProps)(column, [
            'fk_view_id',
            'fk_column_id',
            'show',
            'base_id',
            'source_id'
        ]);
        insertObj.order = await ncMeta.metaGetNextOrder(_globals.MetaTable.GALLERY_VIEW_COLUMNS, {
            fk_view_id: column.fk_view_id
        });
        if (!insertObj.source_id) {
            const viewRef = await _View.default.get(context, insertObj.fk_view_id, ncMeta);
            insertObj.source_id = viewRef.source_id;
        }
        const { id } = await ncMeta.metaInsert2(context.workspace_id, context.base_id, _globals.MetaTable.GALLERY_VIEW_COLUMNS, insertObj);
        // on new view column, delete any optimised single query cache
        {
            const view = await _View.default.get(context, column.fk_view_id, ncMeta);
            await _View.default.clearSingleQueryCache(context, view.fk_model_id, [
                view
            ], ncMeta);
        }
        return this.get(context, id, ncMeta).then(async (viewColumn)=>{
            await _NocoCache.default.appendToList(context, _globals.CacheScope.GALLERY_VIEW_COLUMN, [
                column.fk_view_id
            ], `${_globals.CacheScope.GALLERY_VIEW_COLUMN}:${id}`);
            return viewColumn;
        });
    }
    static async list(context, viewId, ncMeta = _Noco.default.ncMeta) {
        const cachedList = await _NocoCache.default.getList(context, _globals.CacheScope.GALLERY_VIEW_COLUMN, [
            viewId
        ]);
        let { list: views } = cachedList;
        const { isNoneList } = cachedList;
        if (!isNoneList && !views.length) {
            views = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.GALLERY_VIEW_COLUMNS, {
                condition: {
                    fk_view_id: viewId
                },
                orderBy: {
                    order: 'asc'
                }
            });
            await _NocoCache.default.setList(context, _globals.CacheScope.GALLERY_VIEW_COLUMN, [
                viewId
            ], views);
        }
        views.sort((a, b)=>(a.order != null ? a.order : Infinity) - (b.order != null ? b.order : Infinity));
        return views == null ? void 0 : views.map((v)=>new GalleryViewColumn(v));
    }
    static async update(context, columnId, body, ncMeta = _Noco.default.ncMeta) {
        const updateObj = (0, _extractProps.extractProps)(body, [
            'order',
            'show'
        ]);
        // set meta
        const res = await ncMeta.metaUpdate(context.workspace_id, context.base_id, _globals.MetaTable.GALLERY_VIEW_COLUMNS, updateObj, columnId);
        // get existing cache
        const key = `${_globals.CacheScope.GALLERY_VIEW_COLUMN}:${columnId}`;
        await _NocoCache.default.update(context, key, updateObj);
        // on view column update, delete any optimised single query cache
        {
            const viewCol = await this.get(context, columnId, ncMeta);
            const view = await _View.default.get(context, viewCol.fk_view_id, ncMeta);
            await _View.default.clearSingleQueryCache(context, view.fk_model_id, [
                view
            ]);
        }
        return res;
    }
    constructor(data){
        Object.assign(this, data);
    }
};
